export const liveTickerData = [
  { label: "EURUSD Spread", value: "0.6 pips", change: "-0.1", positive: true },
  { label: "Execution Speed", value: "< 50ms", change: "Fast", positive: true },
  { label: "Min Deposit", value: "$5", change: "Low", positive: true },
  { label: "Orders/Sec", value: "99.35%", change: "+0.2%", positive: true },
  { label: "Active Traders", value: "5M+", change: "+120K", positive: true },
  { label: "Regulators", value: "ASIC/CySEC", change: "Verified", positive: true },
];

export const spreadTickerPairs = [
  { pair: "EUR/USD", bid: 1.08452, ask: 1.08458, spread: 0.6, change: "+0.12%" },
  { pair: "GBP/USD", bid: 1.27341, ask: 1.27349, spread: 0.8, change: "-0.05%" },
  { pair: "USD/JPY", bid: 156.832, ask: 156.842, spread: 1.0, change: "+0.24%" },
  { pair: "USD/CHF", bid: 0.90412, ask: 0.90420, spread: 0.8, change: "-0.08%" },
  { pair: "AUD/USD", bid: 0.66542, ask: 0.66550, spread: 0.8, change: "+0.18%" },
  { pair: "USD/CAD", bid: 1.36352, ask: 1.36362, spread: 1.0, change: "-0.03%" },
  { pair: "NZD/USD", bid: 0.61245, ask: 0.61253, spread: 0.8, change: "+0.09%" },
  { pair: "EUR/GBP", bid: 0.85142, ask: 0.85150, spread: 0.8, change: "+0.15%" },
  { pair: "XAU/USD", bid: 2334.52, ask: 2334.70, spread: 1.8, change: "+0.42%" },
  { pair: "XAG/USD", bid: 30.452, ask: 30.482, spread: 3.0, change: "+0.31%" },
  { pair: "BTC/USD", bid: 67234.52, ask: 67236.52, spread: 20.0, change: "+1.24%" },
  { pair: "ETH/USD", bid: 3524.12, ask: 3524.82, spread: 7.0, change: "+0.89%" },
];

export const marketDashboardData = [
  {
    pair: "EUR/USD",
    price: 1.08455,
    spread: 0.6,
    change: 0.12,
    trend: "up",
    volume: "High",
    bars: [45, 52, 48, 60, 55, 70, 68, 75, 80, 85, 82, 90],
  },
  {
    pair: "GBP/USD",
    price: 1.27345,
    spread: 0.8,
    change: -0.05,
    trend: "down",
    volume: "High",
    bars: [80, 75, 82, 70, 78, 65, 72, 60, 68, 55, 62, 58],
  },
  {
    pair: "USD/JPY",
    price: 156.837,
    spread: 1.0,
    change: 0.24,
    trend: "up",
    volume: "High",
    bars: [35, 42, 38, 55, 50, 65, 60, 72, 78, 85, 80, 92],
  },
  {
    pair: "AUD/USD",
    price: 0.66546,
    spread: 0.8,
    change: 0.18,
    trend: "up",
    volume: "Medium",
    bars: [30, 38, 45, 40, 52, 58, 65, 62, 70, 75, 72, 80],
  },
  {
    pair: "USD/CHF",
    price: 0.90416,
    spread: 0.8,
    change: -0.08,
    trend: "down",
    volume: "Medium",
    bars: [70, 65, 72, 60, 68, 55, 62, 58, 50, 45, 52, 48],
  },
  {
    pair: "USD/CAD",
    price: 1.36357,
    spread: 1.0,
    change: -0.03,
    trend: "down",
    volume: "Medium",
    bars: [60, 55, 62, 58, 50, 45, 52, 48, 42, 38, 45, 40],
  },
  {
    pair: "XAU/USD",
    price: 2334.61,
    spread: 1.8,
    change: 0.42,
    trend: "up",
    volume: "Very High",
    bars: [40, 48, 55, 50, 62, 70, 65, 78, 85, 90, 88, 95],
  },
  {
    pair: "BTC/USD",
    price: 67235.52,
    spread: 20.0,
    change: 1.24,
    trend: "up",
    volume: "Very High",
    bars: [25, 35, 30, 45, 55, 50, 65, 75, 70, 85, 80, 92],
  },
];

export const advantagesData = [
  {
    icon: "ri-shield-check-line",
    title: "Top-Tier Regulation",
    description: "Fully licensed by ASIC, CySEC, and FSC. Your funds are held in segregated accounts with negative balance protection.",
    color: "#7C3AED",
  },
  {
    icon: "ri-flashlight-line",
    title: "Ultra-Fast Execution",
    description: "99.35% of orders executed in under 1 second with zero requotes. No dealing desk, pure market execution.",
    color: "#10B981",
  },
  {
    icon: "ri-gift-line",
    title: "Massive Bonus Program",
    description: "$30/50 No-Deposit Bonus + 100% Welcome Bonus up to $500. Loyalty rewards for active traders.",
    color: "#7C3AED",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "24/5 Live Support",
    description: "Professional multi-lingual customer service always online. Average response time under 2 minutes.",
    color: "#10B981",
  },
];

export const accountTypesData = [
  {
    name: "Micro Account",
    badge: "Best for Beginners",
    badgeColor: "#64748B",
    minDeposit: "$5",
    spread: "From 1.0 pip",
    commission: "Zero",
    leverage: "Up to 1:1000",
    lotSize: "1 Lot = 1,000 units",
    instruments: "1,000+ Instruments",
    highlighted: false,
    highlightNote: "Micro lot size for precise risk management. Ideal for beginners and strategy testing.",
  },
  {
    name: "Standard Account",
    badge: "Most Popular",
    badgeColor: "#64748B",
    minDeposit: "$5",
    spread: "From 1.0 pip",
    commission: "Zero",
    leverage: "Up to 1:1000",
    lotSize: "1 Lot = 100,000 units",
    instruments: "1,000+ Instruments",
    highlighted: false,
    highlightNote: "Standard lot sizes. Full bonus eligibility. The classic retail trading account.",
  },
  {
    name: "Ultra Low Account",
    badge: "Lowest Cost",
    badgeColor: "#7C3AED",
    minDeposit: "$5",
    spread: "From 0.6 pips",
    commission: "Zero",
    leverage: "Up to 1:1000",
    lotSize: "Micro & Standard",
    instruments: "1,000+ Instruments",
    highlighted: true,
    highlightNote: "Tightest spreads available. Available in both Micro and Standard lot sizes. No deposit bonus on this account type.",
  },
  {
    name: "Shares Account",
    badge: "Stock Investors",
    badgeColor: "#10B981",
    minDeposit: "$10,000",
    spread: "Exchange-level",
    commission: "Per-share",
    leverage: "Physical shares",
    lotSize: "1 Share = 1 Share",
    instruments: "1,200+ Stocks",
    highlighted: false,
    highlightNote: "Direct access to 1,200+ global stocks across US, UK & EU exchanges. Physical share ownership with dividend rights.",
  },
];

export const prosData = [
  "Low entry barrier ($5 minimum deposit)",
  "Generous promotions and bonuses",
  "Fast and reliable crypto/fiat withdrawals",
  "Wide range of trading instruments (1000+)",
  "Negative balance protection",
  "Multiple platform support (MT4/MT5/Web)",
];

export const consData = [
  "Higher spreads on Stock CFDs",
  "No unlimited leverage option",
  "Limited cryptocurrency pairs",
  "Inactivity fee after 12 months",
  "No cTrader platform support",
];

export const onboardingSteps = [
  {
    step: 1,
    title: "Register & Fill Profile",
    description: "Create your account in under 3 minutes. Provide basic details and select your preferred account type.",
    duration: "Takes 3 mins",
    icon: "ri-user-add-line",
  },
  {
    step: 2,
    title: "Upload ID & Proof of Residence",
    description: "Submit government-issued ID and a recent utility bill or bank statement for KYC verification.",
    duration: "Verified in 24h",
    icon: "ri-shield-check-line",
  },
  {
    step: 3,
    title: "Claim $30 Free Bonus & Start Trading",
    description: "Fund your account, claim your no-deposit bonus, and access 1000+ trading instruments instantly.",
    duration: "Instant access",
    icon: "ri-coins-line",
  },
];

export const fundingMethods = [
  { name: "Visa", icon: "ri-bank-card-line", badge: "Instant Deposit", withdraw: "< 2 Hours" },
  { name: "Mastercard", icon: "ri-mastercard-line", badge: "Instant Deposit", withdraw: "< 2 Hours" },
  { name: "Neteller", icon: "ri-wallet-3-line", badge: "Instant Deposit", withdraw: "< 1 Hour" },
  { name: "Skrill", icon: "ri-wallet-line", badge: "Instant Deposit", withdraw: "< 1 Hour" },
  { name: "Crypto (USDT)", icon: "ri-currency-line", badge: "Instant Deposit", withdraw: "< 30 Mins" },
  { name: "Bank Transfer", icon: "ri-building-4-line", badge: "1-3 Days", withdraw: "1-3 Days" },
];

export const faqData = [
  {
    question: "Is XM a safe and regulated broker?",
    answer:
      "Yes. XM is regulated by multiple top-tier authorities including ASIC (Australia), CySEC (Cyprus), and the FSC (Belize). Client funds are held in segregated bank accounts, and XM provides negative balance protection, meaning you cannot lose more than your deposit.",
  },
  {
    question: "What is the minimum deposit for XM?",
    answer:
      "XM offers a remarkably low entry barrier. You can open a Micro, Standard, or Ultra Low account with just $5. The Ultra Low account offers tighter spreads starting from 0.6 pips, while the Micro and Standard accounts start from 1.0 pip.",
  },
  {
    question: "Does XM offer a no-deposit bonus?",
    answer:
      "Absolutely. XM provides a $30 (or equivalent in your local currency) no-deposit bonus for new verified accounts. You can use it to trade real markets and withdraw profits after meeting the volume requirements. Additionally, a 100% welcome deposit bonus up to $500 is available.",
  },
  {
    question: "What is the difference between Micro and Ultra Low accounts?",
    answer:
      "Micro and Standard accounts have a $5 minimum deposit with spreads starting from 1.0 pip and zero commission. The Ultra Low account also starts at $5, offers tighter spreads from 0.6 pips, and is designed for traders who want better pricing on high-volume strategies.",
  },
  {
    question: "Can I use Expert Advisors (EAs) and automated trading on XM?",
    answer:
      "Yes. XM fully supports Expert Advisors (EAs) and automated trading on both MT4 and MT5 platforms. Execution is fast, slippage is minimal, and there are no restrictions on scalping or algorithmic strategies.",
  },
  {
    question: "How fast are XM deposits and withdrawals?",
    answer:
      "Most e-wallet and card deposits are processed instantly. Withdrawals to e-wallets like Neteller and Skrill typically take under 1 hour, card withdrawals under 2 hours, and crypto (USDT) under 30 minutes. Bank transfers take 1-3 business days.",
  },
  {
    question: "Does XM have negative balance protection?",
    answer:
      "Yes. XM offers negative balance protection on all account types. If extreme market volatility causes your account balance to drop below zero, XM will automatically reset it to zero so you are never liable for losses beyond your deposited funds.",
  },
];

export interface ExpertProfile {
  name: string;
  title: string;
  badge: string;
  rating: number;
  avatar: string;
  quote: string;
}

export const allExperts: ExpertProfile[] = [
  {
    name: "David Vance",
    title: "Former Prop Trader & Senior Market Analyst (London, UK)",
    badge: "Verified Institutional Trader",
    rating: 5,
    avatar: "/images/experts/exp1.jpg",
    quote:
      "Most review sites in the Forex space are just paid marketing mouthpieces. What I respect about this platform is its brutal honesty in the 1v1 comparisons. Breaking down XM's Ultra Low account versus its competitors using real, live spread data is exactly what professional retail traders need to see before opening an account.",
  },
  {
    name: "Dr. Elena Rostova",
    title: "Quantitative Trading Systems Developer (Frankfurt, Germany)",
    badge: "Verified Quant Analyst",
    rating: 5,
    avatar: "/images/experts/exp2.jpg",
    quote:
      "For EA (Expert Advisor) and high-frequency trading, execution latency is everything. This platform doesn't just list broker names; it lists verified execution speeds and slippage metrics. The data transparency provided here—especially when benchmarking XM against IC Markets and Tickmill—is top-tier.",
  },
  {
    name: "Marcus Thorne",
    title: "Founder of FX Trading Academy (Sydney, Australia)",
    badge: "Verified Educator",
    rating: 5,
    avatar: "/images/experts/exp3.jpg",
    quote:
      "I constantly warn my students about broker scams and hidden fees. This site's 'Pros & Cons' and detailed onboarding breakdown for XM are incredibly accurate. It's the first resource I send to my beginner students to help them pick a reliable, low-barrier platform safely.",
  },
  {
    name: "Priya Nair",
    title: "Head of Risk Management at Forex Capital Fund (Singapore)",
    badge: "Verified Risk Strategist",
    rating: 5,
    avatar: "/images/experts/exp4.jpg",
    quote:
      "Risk assessment is what I do for a living. This platform gets it right; the stop-out level comparisons, leverage breakdowns, and negative balance protection analysis are spot-on. It saves my clients hours of DD research across multiple broker websites.",
  },
  {
    name: "Carlos Mendez",
    title: "Full-Time Day Trader & TradingView Top Author (Madrid, Spain)",
    badge: "Verified Professional Trader",
    rating: 5,
    avatar: "/images/experts/exp5.jpg",
    quote:
      "I've been day trading for 12 years and have tried 20+ brokers. The side-by-side spread comparison on this site is brutal and beautiful. Finally someone shows the real numbers: XM's zero-commission Ultra Low at 0.6 pips versus competitors charging $7 per lot. That's a game-changer for retail traders.",
  },
  {
    name: "Yuki Tanaka",
    title: "Algorithmic Trading Strategist (Tokyo, Japan)",
    badge: "Verified Quant Developer",
    rating: 5,
    avatar: "/images/experts/exp6.jpg",
    quote:
      "I run latency-sensitive grid and martingale EAs. Every millisecond counts. This platform's technical infrastructure section gave me the exact server location and execution model data I needed to optimize my bots for XM's LD4 infrastructure. Pure gold for algo traders.",
  },
  {
    name: "Sarah Mitchell",
    title: "Chief Compliance Officer, FinTech Advisory (New York, USA)",
    badge: "Verified Regulatory Expert",
    rating: 5,
    avatar: "/images/experts/exp7.jpg",
    quote:
      "In compliance, we care about one thing: is the broker actually regulated where it claims to be? This platform doesn't take marketing claims at face value; it verifies license numbers and cross-references regulator databases. That level of due diligence is rare and essential for trader protection.",
  },
  {
    name: "Ahmed Al-Rashid",
    title: "Swing Trader & Financial Content Creator (Dubai, UAE)",
    badge: "Verified Market Analyst",
    rating: 5,
    avatar: "/images/experts/exp8.jpg",
    quote:
      "My YouTube audience of 200K traders constantly asks which broker to use. I always point them to this platform first. The onboarding breakdown showing exactly 3 steps from registration to first trade, plus the $30 no-deposit bonus mechanic, makes the decision incredibly easy for beginners.",
  },
  {
    name: "Olga Petrovna",
    title: "Senior Portfolio Manager, Eastern European Desk (Warsaw, Poland)",
    badge: "Verified Investment Strategist",
    rating: 5,
    avatar: "/images/experts/exp9.jpg",
    quote:
      "I manage a diversified portfolio across multiple brokers. This platform's unbiased comparison across XM, Tickmill, IC Markets, and others lets me allocate client capital strategically; higher leverage on XM for certain strategies, Tickmill for ultra-low ECN cost trading. It's become an essential part of my research workflow.",
  },
  {
    name: "James Okonkwo",
    title: "Retail Trader Advocate & Community Lead (Lagos, Nigeria)",
    badge: "Verified Trading Coach",
    rating: 5,
    avatar: "/images/experts/exp10.jpg",
    quote:
      "African retail traders are often targeted by scam brokers with fake bonuses. This platform's transparent breakdown of which bonuses are real (XM's $30 no-deposit is legit; I've tested it myself) versus marketing gimmicks is saving my community members from losing their hard-earned money. This is the kind of honest resource we've been waiting for.",
  },
];